export interface IMockData {
    Id: number;
    Name: string;
    Level: number;
    ChildItems?: IMockData[];
    ParentId?: number;
}

export const mockData: IMockData[] = [
    {
        Id: 1,
        Name: '1',
        Level: 0,
        ChildItems: [
            {
                Id: 11,
                ParentId: 1,
                Name: '11',
                Level: 1,
                ChildItems: [
                    {
                        Id: 111,
                        ParentId: 11,
                        Name: '111',
                        Level: 2,
                    },
                    {
                        Id: 112,
                        ParentId: 11,
                        Name: '112',
                        Level: 2,
                    },
                ],
            },
            {
                ParentId: 1,
                Id: 12,
                Name: '12',
                Level: 1,
            },
        ],
    },
    {
        Id: 2,
        Name: '2',
        Level: 0,
        ChildItems: [],
    },
    {
        Id: 3,
        Name: '3',
        Level: 0,
        ChildItems: [
            {
                Id: 31,
                ParentId: 3,
                Name: '31',
                Level: 1,
            },
            {
                Id: 32,
                ParentId: 3,
                Name: '32',
                Level: 1,
                ChildItems: [
                    {
                        Id: 321,
                        Name: '321',
                        ParentId: 32,
                        Level: 2,
                    },
                    {
                        Id: 322,
                        Name: '322',
                        ParentId: 32,
                        Level: 2,
                    },
                ],
            },
            {
                Id: 33,
                Name: '33',
                ParentId: 3,
                Level: 1,
                ChildItems: [
                    {
                        Id: 331,
                        Name: '331',
                        ParentId: 33,
                        Level: 2,
                        ChildItems: [
                            {
                                Id: 3311,
                                ParentId: 331,
                                Name: '3311',
                                Level: 3,
                                ChildItems: [
                                    {
                                        Id: 33111,
                                        ParentId: 3311,
                                        Name: '33111',
                                        Level: 4,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
